import { createReducer, on } from '@ngrx/store';
import _cloneDeep from 'lodash/cloneDeep';

import { GuideActions } from '../../guide/_state/guide.actions';
import { MazMessage } from '../models/maz-message';
import { MazMessageSender } from '../models/maz-message-sender.enum';

import { MazActions } from './maz.actions';
import { INITIAL_MAZ_STATE, MazState } from './maz.model';

export const MazReducer = createReducer(
  INITIAL_MAZ_STATE,
  on(
    GuideActions.setGuideInfo,
    (state, { guideInfo: { common_questions, common_description } }): MazState => ({
      ...state,
      commonQuestions: common_questions,
      description: common_description,
    })
  ),
  on(
    GuideActions.toggleGuide,
    GuideActions.closeGuide,
    (state): MazState => ({
      ...state,
      mazChatExpanded: false,
    })
  ),
  on(
    MazActions.getConversationHistorySuccess,
    (state, { mazMessages }): MazState => ({ ...state, mazMessages: _cloneDeep(mazMessages) })
  ),
  on(MazActions.toggleMazChat, (state): MazState => ({ ...state, mazChatExpanded: !state.mazChatExpanded })),
  on(MazActions.sendMessageToMaz, (state, { userInput }): MazState => {
    const mazMessages = [..._cloneDeep(state.mazMessages), new MazMessage(userInput)];
    return { ...state, mazMessages, mazChatExpanded: true };
  }),
  on(MazActions.receiveMessageFromMaz, (state, { response: { response, _id } }): MazState => {
    const mazMessages = [..._cloneDeep(state.mazMessages), new MazMessage(response, MazMessageSender.assistant, _id)];
    return { ...state, mazMessages, waitingForMazResponse: false };
  }),
  on(MazActions.waitingForMazReply, (state): MazState => ({ ...state, waitingForMazResponse: true })),
  on(MazActions.failedToReceiveMessageFromMaz, (state): MazState => ({ ...state, waitingForMazResponse: false })),
  on(MazActions.sendMessageFeedback, (state, { feedback: { messageId, ...feedback } }): MazState => {
    const mazMessages = _cloneDeep(state.mazMessages);
    const message = mazMessages.find(m => m._id === messageId);
    message.feedback = {
      ...message.feedback,
      ...feedback,
    };
    return { ...state, mazMessages };
  })
);
